/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import WebFont from "webfontloader";
import { useParams, Redirect, useLocation } from "react-router-dom";
import { contractDataHandle } from "./state/actions";
import { Layout, Row, Modal, message } from "antd";
import "./styles/RenderJsx.css";
import "./styles/FormFromHtml.css";
import { Loading } from "../Common";
import { NotAutharised } from "../Common/components/NotAutharised";
import { ContractNav } from "./components/ContractNav";
import { SomeThingWentWrong } from "../Common/components/SomeThingWentWrong";
import { addLineNumbers, initStrikeThroughPopup, makeAllFieldsDisabled, netSheetItemRemoveConfirmationModal } from "./features/helperFunctions";
import dotEnv from "dotenv";
import OpenCompressed from "./components/OpenCompressed";
import ReactHtmlParser from "react-html-parser";
import { handleClickEvent, handleBlurEvent, handleInputEvent, applyStrikeThroughs, applyHighlights } from "./features/FormLogic/AllForms";
import CobuyerCosellerList from "./components/CobuyerCosellerList";
import SetInitialValues from "./features/SetInitialValues";
import { contractStoreHandle } from "../ContractStore/state/actions";
import AddDocClause from "./components/AddDocClause";
import { PDFview } from "./components/PDFview";
import { closingActions } from "../TransactionReport/state/actions";
import TitleOfficeModal from "./components/TitleOfficeModal";
import { useHistory } from "react-router-dom";
import ModifyDatesModal from "./components/ModifyDatesModal";
import { createOfferInitialState, encryptData, googleFonts } from "../Common/commondata/commonData";
import { filterEmptyAndUndefinedKeys, getAttr, handleShowPicker } from "../Common/utils/universalFuntions";
import axios from "axios";
import EditAgentsModal from "./components/EditAgentsModal";
import EditPropertyAddressModal from "./components/EditPropertyAddressModal";
import NetSheetAddItemModal from "./components/NetSheetAddItemModal";
import SowCompanySelectionModal from "./components/SowCompanySelectionModal";
import SelectDateTableRule from "./components/SelectDateTableRule";
import EditClientDetailsModal from "./components/EditClientDetailsModal";
import HandleSignatureBox from "./components/HandleSignatureBox";
import EditAgentOnList from "./components/EditAgentOnList";
import TitleSignerList from "./components/TitleSignerList";
import AmortizingLoanPopoverModal from "./components/AmortizingLoanPopoverModal";
dotEnv.config();

const { Content } = Layout;

function CreateOffer() {
  const [state, setState] = useState({ jsx: null, navjsx: null });
  const [emailModalOpen, setEmailModalOpen] = useState({
    isEmailModalVisible: false,
    sendMultipleDoc: true,
  });
  const search = useLocation().search;
  const query = new URLSearchParams(search);
  const tabId = query.get("tabId");
  const { pathname } = useLocation();

  const [modalState, setModalState] = useState({ ...createOfferInitialState });

  const history = useHistory();

  const { openTitleCompanyModal, titleOfficeLogoModal, transactionEmail, sharedDocs, getEmailLogsLoading, getEmailLogsData } = useSelector((state) => state.transactionReport);
  const { getTransactionReportData, getSellersData } = useSelector((state) => state.contractStore);
  const { id: urlId } = useParams();
  window.onbeforeunload = function () {
    localStorage.removeItem(urlId);
  };
  const dispatch = useDispatch();
  const { currentUrlId, contractAuthKey, resetSignatureLoading } = useSelector((state) => state.createOffer);

  useEffect(() => {
    let unmounted = {
      value: false,
    };
    let sendEmailSource = {
      source: "client",
    };
    let sourceAxios = axios.CancelToken.source();
    if (urlId) {
      dispatch(contractDataHandle.setUrlIdFun(urlId));
      dispatch(contractDataHandle.getCreateOfferData({ urlId, unmounted, sourceAxios, sendEmailSource, history }));
    }

    return () => {
      dispatch(contractDataHandle.resetCompressedViewData());
      unmounted.value = true;
      sourceAxios.cancel("Cancelling in cleanup");
      if (urlId) {
        localStorage.removeItem(urlId);
      }
    };
  }, [urlId]);

  const { rootDocData, contractData } = useSelector((state) => state.createOffer);
  // setting the html forms after fetching data
  useEffect(() => {
    if (rootDocData?.contractType?.startsWith("WY_")) {
      if (contractData?.html) {
        let transactionData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
        const parser = new DOMParser();
        const doc = parser.parseFromString(contractData.html, "text/html");
        applyStrikeThroughs(doc, transactionData?.strikeThroughSections, transactionData?.highlightSections);
        applyHighlights(doc, transactionData?.highlightSections);
        const formElement = doc.querySelector("form");

        let cleanup;
        if (rootDocData?.contractType !== "WY_SREBD") {
          cleanup = addLineNumbers(formElement);
        }

        const cleanupPopup = initStrikeThroughPopup(transactionData, handleInputSave, currentUrlId);

        const modifiedHtml = `
          <div class="form-wrapper">
            <form id="${formElement?.id || "form"}">
              ${formElement.innerHTML}
            </form>
          </div>
        `;

        setState((prevState) => ({ ...prevState, jsx: ReactHtmlParser(modifiedHtml) }));
        if (contractData?.nav) {
          setState((prevState) => ({ ...prevState, navjsx: ReactHtmlParser(contractData.nav) }));
        }
        return () => {
          if (cleanup) cleanup();
          if (cleanupPopup) cleanupPopup();
        };
      }
    } else {
      if (contractData?.html) {
        setState((prevState) => ({ ...prevState, jsx: ReactHtmlParser(contractData.html) }));
      }
    }

    if (contractData?.nav) {
      setState((prevState) => ({ ...prevState, navjsx: ReactHtmlParser(contractData.nav) }));
    }
  }, [contractData, rootDocData]);


  useEffect(() => {
    WebFont.load({ google: { families: googleFonts } });
  }, []);

  useEffect(() => {
    if (state.jsx && rootDocData) {
      if (rootDocData.contractType === "TR" && getTransactionReportData) {
        SetInitialValues({ currentUrlId, rootDocData, contractAuthKey, getTransactionReportData, getSellersData, transactionEmail, sharedDocs, dispatch, getEmailLogsData });
      } else {
        SetInitialValues({ currentUrlId, rootDocData, contractData, contractAuthKey, getTransactionReportData, dispatch });
      }
    }
  }, [state.jsx, rootDocData, getTransactionReportData, getEmailLogsData]);

  const handleInputSave = useCallback(
    (valueObj) => {
      const filteredObj = filterEmptyAndUndefinedKeys(valueObj);
      if (Object.keys(filteredObj)?.length) {
        dispatch(contractStoreHandle.autoSaveContract({ currentUrlId, contractAuthKey, valueObj: filteredObj }));
      }
    },
    [currentUrlId, contractAuthKey, dispatch]
  );

  const clickHandler = useCallback(
    (event) => {
      handleClickEvent({ event, currentUrlId, rootDocData, dispatch, handleInputSave, handleInput, handleBlur, contractAuthKey });
      let localData = JSON.parse(localStorage.getItem(currentUrlId));
      if (event.target.hasAttribute("data-buyer-edit-icon")) {
        setModalState((prevState) => ({ ...prevState, openClientListModel: true, clientType: "Buyers", editModalTitle: getAttr(event, "data-edit-modal-title"), labelType: getAttr(event, "data-labelType"), addAsSelf: event.target.hasAttribute("data-add-as-self"), clientAlphabetKey: getAttr(event, "data-client-alphabet-key") }));
      } else if (event.target.hasAttribute("data-seller-edit-icon")) {
        if (rootDocData?.openFor === "BUYER") {
          message.info("Only the Buyer's Agent can enter seller names.", 4);
        } else {
          setModalState((prevState) => ({ ...prevState, openClientListModel: true, clientType: "Sellers", editModalTitle: getAttr(event, "data-edit-modal-title"), labelType: getAttr(event, "data-labelType"), addAsSelf: event.target.hasAttribute("data-add-as-self") }));
        }
      } else if (event.target.hasAttribute("data-buyer-details-edit-icon") || event.target.hasAttribute("data-seller-details-edit-icon")) {
        const personId = getAttr(event, "data-signer-personId");
        const signerFieldsRaw = getAttr(event, "data-signer-fields");
        let signerFieldsObj = {};
        try {
          signerFieldsObj = JSON.parse(signerFieldsRaw || "{}");
        } catch (e) {
          console.error("Invalid signerFields JSON", );
        }
        setModalState((prevState) => ({
          ...prevState,
          editClientDetailsModal: true,
          personId: personId?.length === 24 ? personId : null,
          clientType: event.target.hasAttribute("data-buyer-details-edit-icon") ? "Buyers" : "Sellers",
          uuidKey: getAttr(event, "data-signer-uuid-key"),
          corpSigner: event.target.hasAttribute("data-corp-signer"),
          labelType: getAttr(event, "data-labelType"),
          editModalTitle: getAttr(event, "data-edit-modal-title"),
          signerFieldsObj,
        }));
      } else if (event.target.hasAttribute("data-co-buyer-broker-edit-icon") || event.target.hasAttribute("data-co-seller-broker-edit-icon")) {
        const personId = getAttr(event, "data-signer-personId");
        setModalState((prevState) => ({
          ...prevState,
          editAgentsModal: true,
          personId: personId?.length === 24 ? personId : null,
          agentType: getAttr(event, "data-block-is-for") === "CO_BUYER_BROKER" ? "BuyerAgents" : "SellerAgents",
          uuidKey: getAttr(event, "data-signer-uuid-key"),
          individualDetailsEdit: true,
          labelType: getAttr(event, "data-labelType"),
          editModalTitle: getAttr(event, "data-edit-modal-title"),
        }));
      } else if (event.target.hasAttribute("data-add-coBuyerBroker-btn")) {
        setModalState((prevState) => ({ ...prevState, ...(rootDocData?.propertyData?.transactionType === "BUILDER" ? { editAgentOnListModal: true } : { editAgentsModal: true }), agentType: "BuyerAgents", labelType: getAttr(event, "data-labelType"), editModalTitle: getAttr(event, "data-edit-modal-title") }));
      } else if (event.target.hasAttribute("data-add-coSellerBroker-btn")) {
        setModalState((prevState) => ({ ...prevState, editAgentsModal: true, agentType: "SellerAgents", labelType: getAttr(event, "data-labelType"), editModalTitle: getAttr(event, "data-edit-modal-title") }));
      } else if (event.target.hasAttribute("data-referal-form-client-checkbox")) {
        message.error("Please add a client first to enable this checkbox.", 2);
        event.target.checked = false;
        return;
      } else if (contractData?.propertyAddressEditable && event.target.name === "FullAddress") {
        setModalState((prevState) => ({
          ...prevState,
          editPropertyAddressModal: true,
        }));
      } else if (event.target.classList.contains("active-signer")) {
        setModalState((prevState) => ({
          ...prevState,
          event,
          openSignatureModal: true,
        }));
      }

      if (event.target.hasAttribute("data-add-DocClause")) {
        setModalState((prevState) => ({
          ...prevState,
          values: { refName: event.target.dataset.addDocclause, value: event.target.innerText },
          openClauseModal: true,
        }));
      }

      if (event.target.hasAttribute("data-add-title-office")) {
        if (localData?.SelectedBy === undefined || localData?.SelectedBy === "" || rootDocData?.openFor === localData?.SelectedBy) {
          dispatch(closingActions.titleCompanyModalState({ openTitleCompanyModal: true }));
          dispatch(closingActions.getTitleCompany(contractAuthKey));
        }
      }

      if (event.target.classList.contains("relativeDateInput") || event.target.classList.contains("relativeTimeInput")) {
        setModalState((prevState) => ({ ...prevState, showDateFieldModal: true, event }));
      }

      if (rootDocData?.contractType === "TR" && (event.target.hasAttribute("data-open-email") || event.target.hasAttribute("data-open-emailLogs"))) {
        document.cookie = `${tabId}_page2=${pathname}; domain=.resure.realestate; path=/;`;
        // Transaction report > open email logic
        const currentObject = (event.target.dataset.openEmail && JSON.parse(event.target.dataset.openEmail)) || {};
        currentObject.contractAuthKey = contractAuthKey;
        currentObject.rootDocData = rootDocData;
        let encryptedCurrentObject = encryptData(JSON.stringify(currentObject));
        if (currentObject?.source === "EMAIL_LOGS" || event.target.hasAttribute("data-open-emailLogs")) {
          history.push(`/emailLogs?data=${encodeURIComponent(encryptedCurrentObject)}&tabId=${tabId}`);
        } else {
          history.push(`/needToKnowEmails?data=${encodeURIComponent(encryptedCurrentObject)}&tabId=${tabId}`);
        }
      }
      if (rootDocData?.contractType === "NET_SHEET" && rootDocData?.builtForSection !== "READ_ONLY_DOCUMENT" && ((rootDocData?.RTDInitiator === "SELLER" && ["SELLER_AGENT", "TITLE_COMPANY", "SELLER"].includes(rootDocData?.openFor)) || (rootDocData?.RTDInitiator === "BUYER" && ["SELLER_AGENT", "TITLE_COMPANY", "BUYER_AGENT", "BUYER"].includes(rootDocData?.openFor)))) {
        if (event.target.hasAttribute("data-add-item") || event.target.parentElement.hasAttribute("data-add-item")) {
          setModalState((prevState) => ({ ...prevState, netSheetAddItemModal: true }));
        }
        if (event.target.hasAttribute("data-remove-item")) {
          const itemData = JSON.parse(event?.target?.dataset?.removeItem) || {};
          netSheetItemRemoveConfirmationModal(itemData, { td: localData, currentUrlId, dispatch, contractAuthKey });
        }
      }
      if (["SWA", "SPD"].includes(rootDocData?.contractType) && event.target.hasAttribute("data-select-sow")) {
        setModalState((prevState) => ({ ...prevState, SOWSelectCompanyModal: true }));
      }
      if (event.target.hasAttribute("data-modifyDateTableRule")) {
        setModalState((prevState) => ({ ...prevState, openSelectRuleModal: true }));
      }
      if (event.target.hasAttribute("data-title-signer-list")) {
        setModalState((prevState) => ({ ...prevState, showTitleSignerList: true }));
      }
      if (event.target.hasAttribute("data-calculate-loan") || event.target.dataset?.calculateLoan === "AmortizingLoan") {
        setModalState((prevState) => ({ ...prevState, amortizingLoanPopoverModal: true }));
      }
    },
    [currentUrlId, rootDocData, dispatch, history]
  );

  const handleInput = useCallback(
    (event) => {
      handleInputEvent({ event, currentUrlId, handleInputSave, rootDocData, contractData });
    },
    [currentUrlId, handleInputSave, rootDocData]
  );

  const handleBlur = useCallback(
    (event) => {
      handleBlurEvent({ event, currentUrlId, handleInputSave, rootDocData, contractData });
    },
    [currentUrlId, handleInputSave, rootDocData]
  );
  const keyDownHandler = (event) => {
    if (event.key === "Enter") {
      handleBlur(event);
    }
  };

  useEffect(() => {
    if (state.jsx && rootDocData) {
      document.querySelectorAll(".clickable")?.forEach((element) => {
        element.addEventListener("click", clickHandler);
      });
      document.querySelectorAll("input,textarea")?.forEach((element) => {
        if (element.name !== "no-event" && (element.disabled === false || element.name === "FullAddress")) {
          if (element.type === "date") {
            element.addEventListener("click", handleShowPicker);
          }
          if (element.name === "FullAddress") {
            element.classList.remove("no-edit");
            element.classList.add("clickable");
            element.readOnly = true;
            element.removeAttribute("disabled");
            element.addEventListener("click", clickHandler);
          }
          element.addEventListener("input", handleInput);
          element.addEventListener("blur", handleBlur);
          element.addEventListener("keydown", keyDownHandler);
        }
      });

      let formWrapper = document.querySelector(".form-wrapper");
      if (formWrapper) {
        let zoom = 1;
        document.querySelector(".zoom-plus-button_1")?.addEventListener("click", function () {
          formWrapper.style.transform = `scale(${(parseFloat(zoom) + 0.2).toFixed(2)})`;
          formWrapper.style.transformOrigin = "top left";
          zoom = parseFloat(zoom) + 0.2;
        });
        document.querySelector(".zoom-minus-button_1")?.addEventListener("click", function () {
          if (zoom - 1 > 0) {
            formWrapper.style.transform = `scale(${(parseFloat(zoom) - 0.2).toFixed(2)})`;
            zoom = parseFloat(zoom) - 0.2;
          }
        });
      }
    }

    // Cleanup function to remove the event listeners
    return () => {
      document.querySelectorAll(".clickable")?.forEach((element) => {
        element.removeEventListener("click", clickHandler);
      });

      document.querySelectorAll("input,textarea")?.forEach((element) => {
        if (element.type === "date") {
          element.removeEventListener("click", handleShowPicker);
        }

        element.removeEventListener("input", handleInput);
        element.removeEventListener("blur", handleBlur);
        element.removeEventListener("keydown", keyDownHandler);
      });
    };
  }, [state.jsx, rootDocData, getTransactionReportData]);

  let handleCancel = () => {
    setModalState((prevState) => ({ ...prevState, openClientListModel: false }));
  };

  // All fields disabled logic
  useEffect(() => {
    if (state.jsx && currentUrlId && rootDocData) {
      makeAllFieldsDisabled(currentUrlId, rootDocData, contractData);
    }

    return () => {};
  }, [state.jsx, currentUrlId, rootDocData]);

  const { contractError, loadingSave, error } = useSelector((state) => state.createOffer);

  setTimeout(() => {
    let rpanrResize = document.getElementById("rpanrResize");
    let pan1 = rootDocData?.contractType?.startsWith("WY_")?document.getElementById("WY_pan1"):document.getElementById("pan1");
    let ismdwn = 0;
    rpanrResize && rpanrResize.addEventListener("mousedown", mD);

    function mD(event) {
      ismdwn = 1;
      document.body.addEventListener("mousemove", mV);
      document.body.addEventListener("mouseup", end);
    }

    function mV(event) {
      if (ismdwn === 1) {
        pan1.style.flexBasis = event.clientX + "px";
      } else {
        end();
      }
    }
    const end = (e) => {
      ismdwn = 0;
      document.body.removeEventListener("mouseup", end);
      rpanrResize && rpanrResize.removeEventListener("mousemove", mV);
    };
  }, 300);

  const renderPdfView = useMemo(() => <PDFview jsx={state.jsx} navjsx={state.navjsx} />, [state.jsx, state.navjsx]);

  if (!urlId) {
    return <Redirect to="/error" />;
  }
  if (contractError) {
    return (
      <div style={{ height: "100vh" }}>
        <NotAutharised flag={true} />
      </div>
    );
  }

  return (
    <>
      {loadingSave || !contractData || resetSignatureLoading || getEmailLogsLoading ? (
        <div style={{ height: "100%" }}>
          <Loading />
        </div>
      ) : error ? (
        <SomeThingWentWrong message={error.message} status={error.statusCode} />
      ) : (
        <Layout style={{ background: "#F0F2F5", height: "100%" }}>
          <>
            {contractData && state.jsx && <ContractNav emailModalOpen={emailModalOpen} setEmailModalOpen={setEmailModalOpen} />}
            <Content style={{ width: "-webkit-fill-available" }}>
              {contractData && state.jsx && state.navjsx ? (
                <Row style={{ rowGap: "1px", position: "absolute", width: "-webkit-fill-available" }}>
                  <div className="reSizerWrapper">
                    <div id={rootDocData?.contractType?.startsWith("WY_")?"WY_pan1":"pan1"} className="form-from-html no-print">
                      <div style={{ overflowY: "scroll" }} className="no-print">
                        {state.navjsx}
                      </div>
                    </div>
                    <div id="rpanrResize" style={{ display: "flex", alignItems: "center" }} className="no-print">
                      <OpenCompressed />
                    </div>
                    <div id="pan2" className="print htmlElements form-from-html">
                      {renderPdfView}
                    </div>
                  </div>
                </Row>
              ) : (
                <div id="pan2" className="print htmlElements form-from-html withoutNav">
                  {state.jsx && renderPdfView}
                </div>
              )}
            </Content>
          </>
        </Layout>
      )}
      {modalState?.openClientListModel && (
        <Modal visible={true} width={"600px"} title={<div className="commonModalTitle">{modalState.editModalTitle ? modalState.editModalTitle : modalState.clientType === "Buyers" ? "Edit Buyer(s)" : `Edit ${rootDocData?.contractType === "ERTL" ? "Landlord(s)" : rootDocData?.contractType === "ETCT" ? "Tenant(s)" : "Seller(s)"}`}</div>} onCancel={handleCancel} footer={false}>
          <CobuyerCosellerList contractAuthKey={contractAuthKey} rootDocData={rootDocData} currentUrlId={currentUrlId} modalState={modalState} contractData={contractData} />
        </Modal>
      )}
      {modalState?.editAgentOnListModal && <EditAgentOnList modalState={modalState} setModalState={setModalState} currentUrlId={currentUrlId} handleInputSave={handleInputSave} rootDocData={rootDocData} contractAuthKey={contractAuthKey} contractData={contractData} />}
      {modalState?.editAgentsModal && <EditAgentsModal modalState={modalState} setModalState={setModalState} currentUrlId={currentUrlId} handleInputSave={handleInputSave} rootDocData={rootDocData} contractAuthKey={contractAuthKey} contractData={contractData} />}
      {modalState?.editClientDetailsModal && <EditClientDetailsModal modalState={modalState} setModalState={setModalState} currentUrlId={currentUrlId} handleInputSave={handleInputSave} rootDocData={rootDocData} contractAuthKey={contractAuthKey} contractData={contractData} />}
      {modalState?.openClauseModal && <AddDocClause setOpenClauseModal={(openClauseModal) => setModalState((prevState) => ({ ...prevState, openClauseModal }))} currentUrlId={currentUrlId} values={modalState.values} contractAuthKey={contractAuthKey} handleInputSave={handleInputSave} />}
      {(openTitleCompanyModal || titleOfficeLogoModal) && <TitleOfficeModal />}
      {modalState?.showDateFieldModal && <ModifyDatesModal modalState={modalState} setModalState={setModalState} currentUrlId={currentUrlId} handleInputSave={handleInputSave} rootDocData={rootDocData} />}
      {modalState?.editPropertyAddressModal && <EditPropertyAddressModal modalState={modalState} setModalState={setModalState} currentUrlId={currentUrlId} handleInputSave={handleInputSave} rootDocData={rootDocData} contractAuthKey={contractAuthKey} contractData={contractData} />}
      {modalState?.netSheetAddItemModal && <NetSheetAddItemModal modalState={modalState} setModalState={setModalState} currentUrlId={currentUrlId} contractAuthKey={contractAuthKey} />}
      {modalState?.SOWSelectCompanyModal && <SowCompanySelectionModal rootDocData={rootDocData} setModalState={setModalState} currentUrlId={currentUrlId} contractAuthKey={contractAuthKey} handleInputSave={handleInputSave} />}
      {modalState?.openSelectRuleModal && <SelectDateTableRule modalState={modalState} setModalState={setModalState} currentUrlId={currentUrlId} contractAuthKey={contractAuthKey} contractData={contractData} />}
      {/* modal openig after signature click */}
      {modalState?.openSignatureModal && <HandleSignatureBox modalState={modalState} setModalState={setModalState} currentUrlId={currentUrlId} rootDocData={rootDocData} />}
      {modalState?.showTitleSignerList && <TitleSignerList modalState={modalState} setModalState={setModalState} rootDocData={rootDocData} accessToken={contractAuthKey} currentUrlId={currentUrlId} />}
      {modalState?.amortizingLoanPopoverModal && <AmortizingLoanPopoverModal modalState={modalState} setModalState={setModalState} rootDocData={rootDocData} accessToken={contractAuthKey} currentUrlId={currentUrlId} handleInputSave={handleInputSave} />}
    </>
  );
}

export { CreateOffer };
